import { IPostEquipo, IPostEquipoModelo, IPostRazon, IRazonSincronia, ITipoEquipoPost, IUbicacionPost } from "../../Interfaces/estadoEquipos/IEstadoEquipo";
import { Ifilter } from "../../Interfaces/filter";
import { fetchListVerificacion } from "../http-common";

const Integracion = "Integracion";
const GetEstado = (codigo:string) => {
    return fetchListVerificacion.get(`${Integracion}/ListarEstadoEquipoUnico?Codigo=${codigo}`);
}; 
const GetRazones=()=>{
    return fetchListVerificacion.get(`${Integracion}/RazonIntegracion`);
}
const GetUbicaciones=(nivel:number)=>{
    return fetchListVerificacion.get(`${Integracion}/UbicacionIntegracion?Nivel=${nivel}`);
}
const GetTiposEquipos=()=>{
    return fetchListVerificacion.get(`${Integracion}/TipoEquipoIntegracion`);
}
const GetEquipoModelos=()=>{
    return fetchListVerificacion.get(`${Integracion}/EquipoModeloIntegracion`);
}
const GetEquipos=()=>{
    return fetchListVerificacion.get(`${Integracion}/EquiposIntegracion`);
}
const PostUbicacion=(request:IUbicacionPost)=>{
    return fetchListVerificacion.post(`${Integracion}/CrearUbicacionesIntegracion`,request);
}

const PostRazon=(request:IRazonSincronia)=>{
    return fetchListVerificacion.post(`${Integracion}/CrearRazonIntegracion`,request);
}
const PostTipoEquipo=(request:ITipoEquipoPost)=>{
    return fetchListVerificacion.post(`${Integracion}/CrearTipoEquipoIntegracion`,request);
}
const PostEquipoModelo=(request:IPostEquipoModelo)=>{
    return fetchListVerificacion.post(`${Integracion}/CrearEquipoModeloIntegracion`,request);
}
const PostEquipo=(request:IPostEquipo)=>{
    return fetchListVerificacion.post(`${Integracion}/CrearEquipoIntegracion`,request);
}
const BackGround=()=>{
    return fetchListVerificacion.post(`${Integracion}/BackGround`
    );
}

const ActualizarRazonesModelos=()=>{
    return fetchListVerificacion.post(`${Integracion}/ActualizarRazonesModelos`
    );
}
const IntegracionService = {
    GetEstado,GetRazones,GetUbicaciones,GetTiposEquipos,PostUbicacion,PostRazon,PostTipoEquipo,GetEquipoModelos
    ,PostEquipoModelo,GetEquipos,PostEquipo,BackGround,ActualizarRazonesModelos
}

export { IntegracionService };